<template>
  <div class="mobile" @click="close">
    <div class="d-flex justify-content-center mt-4" style="width: 100%">
      <ul class="m-0 p-4">
        <a
          v-for="(data, i) in nav"
          :key="i"
          :value="data"
          @click="close"
          style="height: 40px; width: 120px"
          type="button"
          class="btn btn-warning m-2"
          :href="`#${data.name.split(' ')[0]}`"
          >{{ data.name.split(" ")[0] }}</a
        >
      </ul>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";

export default {
  props: {
    nav: Object,
  },
  name: "mobile-menu",
  components: {},
  data() {
    return {};
  },

  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style>
.mobile {
  z-index: 21;
  display: flex;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.651);
  width: 100%;
  height: 100%;
}
@media (max-width: 575.98px) {
}
</style>
